import Loadable from 'react-loadable';

import { Loading } from '@dom/components';

const AsyncFooter = Loadable({
    loader: () => import('./Footer'),
    loading: Loading
});

export default AsyncFooter;
